import { render } from "./orderView.vue?vue&type=template&id=1a83dc6d&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"

import "./orderView.vue?vue&type=style&index=0&id=1a83dc6d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a83dc6d"]])

export default __exports__